var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-item"},[_c('div',{staticClass:"grid-block img-block"},[(_vm.user.image)?_c('img',{attrs:{"src":_vm.user.image}}):_c('img',{attrs:{"src":require("@/assets/images/avatar.png")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }